import "../App.css";
import { Button, Drawer, Layout, Menu, Avatar } from "antd";
import * as icon from "@ant-design/icons";
import { Fragment, useState } from "react";
import { Outlet } from "react-router";
import { Link } from "react-router-dom";
import { getUser, hasPermission, logout, PERMISSIONS } from "@model";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";
import MenuItem from "antd/lib/menu/MenuItem";
import { useIsCompact } from "../hooks/useIsCompact";
const { Header, Content } = Layout;
function App() {
  const isCompact = useIsCompact();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: isCompact ? "0 12px" : "0 24px",
          background: "#001529",
        }}
      >
        {isCompact && (
          <Button
            type="text"
            aria-label="Open menu"
            icon={<MenuOutlined style={{ color: "#fff", fontSize: 18 }} />}
            onClick={() => setMenuOpen(true)}
          />
        )}
        <Menu
          theme="dark"
          mode="horizontal"
          style={{
            flex: 1,
            minWidth: 0,
            display: isCompact ? "none" : undefined,
          }}
        >
          {hasPermission(PERMISSIONS.dashboardView) && <MenuItem
            key="dashboard"
            icon={<icon.DashboardFilled />}
            id="dashboard"
          >
            <Link to="/panel/dashboard">Dashboard</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.charactersView) && <MenuItem
            key="characterList"
            icon={<icon.UsergroupAddOutlined />}
            id="characterList"
          >
            <Link to="/panel/characters">Characters</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.usersView) && <MenuItem key="userList" icon={<icon.UserOutlined />} id="userList">
            <Link to="/panel/users">Users</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.reportsView) && <MenuItem key="reports" icon={<icon.WarningOutlined />} id="reports">
            <Link to="/panel/reports">Reports</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.paymentsView) && <MenuItem key="payments" icon={<icon.DollarOutlined />} id="payments">
            <Link to="/panel/payments">Payments</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.wordsView) && <MenuItem key="words" icon={<icon.FileTextOutlined />} id="words">
            <Link to="/panel/words">Words</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.wordCardsView) && <MenuItem key="wordCards" icon={<icon.BookOutlined />} id="wordCards">
            <Link to="/panel/word-cards">Word cards</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.chatLessonsView) && <MenuItem
            key="chatLessons"
            icon={<icon.MessageOutlined />}
            id="chatLessons"
          >
            <Link to="/panel/chat-lessons">Chat Lessons</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.journeysView) && <MenuItem
            key="journeys"
            icon={<icon.NodeIndexOutlined />}
            id="journeys"
          >
            <Link to="/panel/journeys">Journeys</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.surveysView) && <MenuItem
            key="surveys"
            icon={<icon.FormOutlined />}
            id="surveys"
          >
            <Link to="/panel/surveys">Surveys</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.notificationsView) && <MenuItem
            key="notifications"
            icon={<icon.NotificationOutlined />}
            id="notifications"
          >
            <Link to="/panel/notifications">Notification</Link>
          </MenuItem>}
          {hasPermission(PERMISSIONS.settingsView) && <MenuItem key="settings" icon={<icon.SettingFilled />} id="settings">
            <Link to="/panel/settings">Settings</Link>
          </MenuItem>}
        </Menu>
        <Menu
          theme="dark"
          mode="horizontal"
          className="none-underline-menu"
          style={{ minWidth: "auto" }}
        >
          <Menu.SubMenu
            key="u1"
            popupClassName="account-menu-popup"
            title={
              <Fragment>
                <div
                  style={{
                    userSelect: "none",
                  }}
                >
                  <span
                    style={{
                      color: "#a5a5a5",
                      fontSize: "9pt",
                      marginRight: 6,
                    }}
                  >
                    ({getUser()?.username})
                  </span>

                  <Avatar className="user-avatar-icon">
                    <UserOutlined />
                  </Avatar>
                </div>
              </Fragment>
            }
          >
            {hasPermission(PERMISSIONS.settingsView) && <Menu.Item key="profile">
              <Link to={"/panel/settings"}>Settings</Link>
            </Menu.Item>}
            <Menu.Item
              onClick={() => {
                logout();
                window.location.reload();
              }}
              key="signOut"
            >
              SignOut
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      </Header>
      <Drawer
        title="Menu"
        placement="left"
        visible={menuOpen}
        onClose={closeMenu}
        bodyStyle={{ padding: 0, background: "#001529" }}
        width={280}
      >
        <Menu theme="dark" mode="inline" selectable={false} onClick={closeMenu}>
          {hasPermission(PERMISSIONS.dashboardView) && (
            <Menu.Item key="dashboard" icon={<icon.DashboardFilled />}>
              <Link to="/panel/dashboard">Dashboard</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.charactersView) && (
            <Menu.Item key="characterList" icon={<icon.UsergroupAddOutlined />}>
              <Link to="/panel/characters">Characters</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.usersView) && (
            <Menu.Item key="userList" icon={<icon.UserOutlined />}>
              <Link to="/panel/users">Users</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.reportsView) && (
            <Menu.Item key="reports" icon={<icon.WarningOutlined />}>
              <Link to="/panel/reports">Reports</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.paymentsView) && (
            <Menu.Item key="payments" icon={<icon.DollarOutlined />}>
              <Link to="/panel/payments">Payments</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.wordsView) && (
            <Menu.Item key="words" icon={<icon.FileTextOutlined />}>
              <Link to="/panel/words">Words</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.chatLessonsView) && (
            <Menu.Item key="chatLessons" icon={<icon.MessageOutlined />}>
              <Link to="/panel/chat-lessons">Chat Lessons</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.journeysView) && (
            <Menu.Item key="journeys" icon={<icon.NodeIndexOutlined />}>
              <Link to="/panel/journeys">Journeys</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.surveysView) && (
            <Menu.Item key="surveys" icon={<icon.FormOutlined />}>
              <Link to="/panel/surveys">Surveys</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.notificationsView) && (
            <Menu.Item key="notifications" icon={<icon.NotificationOutlined />}>
              <Link to="/panel/notifications">Notification</Link>
            </Menu.Item>
          )}
          {hasPermission(PERMISSIONS.settingsView) && (
            <Menu.Item key="settings" icon={<icon.SettingFilled />}>
              <Link to="/panel/settings">Settings</Link>
            </Menu.Item>
          )}
        </Menu>
      </Drawer>
      <Layout className="site-layout">
        <Content style={{ margin: "16px", minHeight: "calc(100vh - 134px)" }}>
          {<Outlet />}
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
